/* ============================================================================

   BANNER BUILDER PREMIUM - MOTOR JS

   ----------------------------------------------------------------------------

   Motor reutilizable. Este archivo NO cambia entre productos.

   Cada banner en la página trae su propia configuración incrustada en un

   config JSON element dentro de la sección,

   y este motor la lee para saber qué componentes activar y con qué valores.



   ÍNDICE DE MÓDULOS

   1. UTILS              → helpers puros (random, pad, clamp, prefiere-reducido)

   2. PARTICLE ENGINE     → sistema genérico de partículas cayendo + explosión

   3. COUNTDOWN ENGINE     → temporizador configurable con loop automático

   4. LIVE VIEWERS ENGINE  → contador de "personas viendo esto" (simulado)

   5. COMPONENT REGISTRY   → mapea nombre de componente → función que lo inicia

   6. BOOTSTRAP            → lee la config de cada banner en la página y arranca

   ============================================================================ */



(function (window, document) {

  'use strict';



  var BannerBuilder = {};





  /* ==========================================================================

     1. UTILS

     ========================================================================== */

  var Utils = {

    rand: function (min, max) { return min + Math.random() * (max - min); },

    randInt: function (min, max) { return Math.floor(Utils.rand(min, max + 1)); },

    pad: function (n) { return n.toString().padStart(2, '0'); },

    prefersReducedMotion: function () {

      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    },

    pick: function (arr) { return arr[Utils.randInt(0, arr.length - 1)]; },

    starPath: 'M12 2.5l2.7 5.6 6.1.7-4.5 4.3 1.1 6.1L12 16.2l-5.4 2.9 1.1-6.1L3.2 8.8l6.1-.7z'

  };

  BannerBuilder.Utils = Utils;





  /* ==========================================================================

     2. PARTICLE ENGINE

     ----------------------------------------------------------------------------

     Genera partículas que caen dentro de un contenedor. Sirve tanto para una

     "lluvia" de fondo que atraviesa todo el banner (estrellitas) como para

     partículas que viajan de un punto A a un punto B (ej. canchita saliendo

     de una máquina hacia un tazón), controlado por `mode`.



     config = {

       container: HTMLElement,

       mode: 'rain' | 'stream',

       count: number,

       colors: [hex, hex, ...],

       shape: 'star' | 'circle' | 'custom',

       customShapeHTML: string (si shape === 'custom'),

       burst: boolean,                 // ¿explota al llegar abajo/al final?

       sizeMin, sizeMax: number (px),

       durationMin, durationMax: number (segundos),

       delayMax: number (segundos),

       // solo modo 'stream':

       startX,startY,endX,endY: [min, max] en % (rango para variar cada partícula)

     }

     ========================================================================== */

  var ParticleEngine = {

    init: function (config) {

      if (!config || !config.container) return;

      if (Utils.prefersReducedMotion()) return;



      var mode = config.mode || 'rain';

      if (mode === 'rain') {

        ParticleEngine._initRain(config);

      } else if (mode === 'stream') {

        ParticleEngine._initStream(config);

      }

    },



    _shapeSVG: function (color, shape, customHTML) {

      if (shape === 'custom' && customHTML) return customHTML.replace(/__COLOR__/g, color);

      if (shape === 'circle') {

        return '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" fill="' + color + '"/></svg>';

      }

      // default: star

      return '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="' + color + '" d="' + Utils.starPath + '"/></svg>';

    },



    _burstSVG: function (color) {

      var rays = '';

      for (var r = 0; r < 6; r++) {

        var angle = (360 / 6) * r;

        rays += '<line x1="13" y1="13" x2="13" y2="4" stroke="' + color + '" stroke-width="1.6" stroke-linecap="round" transform="rotate(' + angle + ' 13 13)"/>';

      }

      return '<svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">' + rays + '<circle cx="13" cy="13" r="2" fill="' + color + '"/></svg>';

    },



    /* Lluvia de fondo: cae de arriba hacia abajo del contenedor, en loop. */

    _initRain: function (config) {

      var container = config.container;

      var host = config.heightRef || container;

      var count = config.count || 10;

      var colors = config.colors || ['#BE8C56'];

      var burst = config.burst !== false;



      for (var i = 0; i < count; i++) {

        var fallDistance = (host.offsetHeight || 700) + 20;

        var size = Utils.rand(config.sizeMin || 4, config.sizeMax || 8);

        var left = Utils.rand(4, 96);

        var duration = Utils.rand(config.durationMin || 7, config.durationMax || 12);

        var delay = Utils.rand(0, config.delayMax || 10);

        var color = Utils.pick(colors);



        var star = document.createElement('div');

        star.className = 'bb-particle';

        star.style.left = left + '%';

        star.style.top = '-14px';

        star.style.width = size + 'px';

        star.style.height = size + 'px';

        star.style.setProperty('--bb-fall-distance', fallDistance + 'px');

        star.style.animation = 'bb-kf-particle-fall ' + duration + 's linear ' + delay + 's infinite';

        star.innerHTML = ParticleEngine._shapeSVG(color, config.shape, config.customShapeHTML);

        container.appendChild(star);



        if (burst) {

          var burstEl = document.createElement('div');

          burstEl.className = 'bb-particle-burst';

          burstEl.style.left = left + '%';

          burstEl.style.top = 'calc(100% - 4px)';

          burstEl.style.width = '11px';

          burstEl.style.height = '11px';

          burstEl.style.marginLeft = '-5.5px';

          burstEl.style.marginTop = '-5.5px';

          burstEl.style.setProperty('--bb-burst-duration', duration + 's');

          burstEl.style.setProperty('--bb-burst-delay', delay + 's');

          burstEl.style.animation = 'bb-kf-particle-burst ' + duration + 's ease-out ' + delay + 's infinite';

          burstEl.innerHTML = ParticleEngine._burstSVG(color);

          container.appendChild(burstEl);

        }

      }

    },



    /* Flujo dirigido: cada partícula viaja de un punto A a un punto B con una

       curva intermedia (para que no se vea como una línea recta perfecta). */

    _initStream: function (config) {

      var container = config.container;

      var count = config.count || 8;

      var cssRules = '';



      for (var i = 0; i < count; i++) {

        var startX = Utils.rand(config.startX[0], config.startX[1]);

        var startY = Utils.rand(config.startY[0], config.startY[1]);

        var endX = Utils.rand(config.endX[0], config.endX[1]);

        var endY = Utils.rand(config.endY[0], config.endY[1]);

        var midX = (startX + endX) / 2 + Utils.rand(-3, 3);

        var midY = (startY + endY) / 2 + Utils.rand(-2, 2);

        var rotStart = Utils.randInt(0, 60);

        var rotEnd = rotStart + Utils.randInt(140, 300);

        var rotMid = (rotStart + rotEnd) / 2;

        var size = Utils.rand(config.sizeMin || 7, config.sizeMax || 13);

        var duration = Utils.rand(config.durationMin || 1.5, config.durationMax || 2.6);

        var delay = Utils.rand(0, config.delayMax || 2.4);

        var keyName = 'bb-kf-stream-' + config.instanceId + '-' + i;



        cssRules += '@keyframes ' + keyName + ' {' +

          '0% { top:' + startY.toFixed(1) + '%; left:' + startX.toFixed(1) + '%; opacity:0; transform: rotate(' + rotStart + 'deg) scale(0.7); }' +

          '10% { opacity:1; }' +

          '55% { top:' + midY.toFixed(1) + '%; left:' + midX.toFixed(1) + '%; opacity:1; transform: rotate(' + rotMid.toFixed(0) + 'deg) scale(1); }' +

          '88% { opacity:1; }' +

          '96% { top:' + endY.toFixed(1) + '%; left:' + endX.toFixed(1) + '%; opacity:0.9; transform: rotate(' + rotEnd.toFixed(0) + 'deg) scale(1); }' +

          '100% { top:' + endY.toFixed(1) + '%; left:' + endX.toFixed(1) + '%; opacity:0; transform: rotate(' + rotEnd.toFixed(0) + 'deg) scale(0.85); }' +

        '}';



        var particle = document.createElement('div');

        particle.className = 'bb-particle bb-particle--stream';

        particle.style.width = size.toFixed(1) + 'px';

        particle.style.height = (size * 0.9).toFixed(1) + 'px';

        particle.style.borderRadius = '46% 54% 58% 42% / 55% 44% 56% 45%';

        particle.style.background = config.streamGradient ||

          'radial-gradient(circle at 34% 30%, #FFFDF6 0%, #F3E3B8 42%, #E0B978 72%, #BE8C56 100%)';

        particle.style.boxShadow = '0 1px 2px rgba(74,46,31,0.28)';

        particle.style.animationName = keyName;

        particle.style.animationDuration = duration.toFixed(2) + 's';

        particle.style.animationDelay = delay.toFixed(2) + 's';

        particle.style.animationTimingFunction = 'ease-in';

        particle.style.animationIterationCount = 'infinite';

        container.appendChild(particle);



        if (config.burst !== false) {

          var burstEl = document.createElement('div');

          burstEl.className = 'bb-particle-burst bb-particle-burst--stream';

          burstEl.style.left = endX.toFixed(1) + '%';

          burstEl.style.top = endY.toFixed(1) + '%';

          burstEl.style.width = '15px';

          burstEl.style.height = '15px';

          burstEl.style.marginLeft = '-7.5px';

          burstEl.style.marginTop = '-7.5px';

          burstEl.style.setProperty('--bb-burst-duration', duration.toFixed(2) + 's');

          burstEl.style.setProperty('--bb-burst-delay', delay.toFixed(2) + 's');

          container.appendChild(burstEl);

        }

      }



      if (cssRules) {

        var styleEl = document.createElement('style');

        styleEl.textContent = cssRules;

        document.head.appendChild(styleEl);

      }

    }

  };

  BannerBuilder.ParticleEngine = ParticleEngine;





  /* ==========================================================================

     3. COUNTDOWN ENGINE

     ----------------------------------------------------------------------------

     config = {

       elements: { h: HTMLElement|null, m: HTMLElement, s: HTMLElement|null, d: HTMLElement|null },

       startSeconds: number,   // duración total al cargar / al reiniciar

       loop: boolean,          // ¿reinicia solo al llegar a cero?

       tickMs: number          // 1000 = por segundo, 60000 = por minuto

     }

     ========================================================================== */

  var CountdownEngine = {

    init: function (config) {

      var els = config.elements || {};

      var hasAny = (els.h && els.h.length) || (els.m && els.m.length) || (els.s && els.s.length) || (els.d && els.d.length);

      if (!hasAny) return;



      var total = config.startSeconds;

      var loop = config.loop !== false;

      var tickMs = config.tickMs || 1000;

      var tickSeconds = tickMs / 1000;



      function setAll(list, text) {

        if (!list) return;

        for (var i = 0; i < list.length; i++) { list[i].textContent = text; }

      }



      function render() {

        var remaining = total;

        if (els.d && els.d.length) {

          var d = Math.floor(remaining / 86400);

          setAll(els.d, Utils.pad(d));

          remaining -= d * 86400;

        }

        var h = Math.floor(remaining / 3600);

        var m = Math.floor((remaining % 3600) / 60);

        var s = Math.floor(remaining % 60);

        setAll(els.h, Utils.pad(h));

        setAll(els.m, Utils.pad(m));

        setAll(els.s, Utils.pad(s));

      }



      render();

      setInterval(function () {

        total -= tickSeconds;

        if (total < 0) {

          if (loop) { total = config.startSeconds; }

          else { total = 0; }

        }

        render();

      }, tickMs);

    }

  };

  BannerBuilder.CountdownEngine = CountdownEngine;





  /* ==========================================================================

     4. LIVE VIEWERS ENGINE

     ----------------------------------------------------------------------------

     "N personas viendo esto ahora" - número que fluctúa suavemente dentro de

     un rango, para transmitir actividad en vivo sin datos reales de tráfico.

     Si se pasa `rampUp` (array de números), primero sube por esos valores

     antes de empezar a fluctuar al azar - imita a más gente "sumándose".

     config = { element: HTMLElement, min, max, intervalMs, rampUp: number[] }

     ========================================================================== */

  var LiveViewersEngine = {

    init: function (config) {

      var el = config.element;

      if (!el) return;

      var min = config.min || 8;

      var max = config.max || 34;

      var rampUp = config.rampUp || null;

      var rampIndex = 0;

      var current = rampUp ? rampUp[0] : Utils.randInt(min, max);

      el.textContent = current;



      function setValue(v) {

        var swap = el.closest ? el.closest('.bb-fade-swap') : null;

        var target = swap || el;

        target.classList.add('bb-fading');

        setTimeout(function () {

          current = v;

          el.textContent = current;

          target.classList.remove('bb-fading');

        }, 220);

      }



      function tick() {

        if (rampUp && rampIndex < rampUp.length - 1) {

          rampIndex++;

          setValue(rampUp[rampIndex]);

        } else {

          var delta = Utils.randInt(-3, 3);

          var next = Math.max(min, Math.min(max, current + delta));

          setValue(next);

        }

      }



      setInterval(tick, config.intervalMs || 4000);

    }

  };

  BannerBuilder.LiveViewersEngine = LiveViewersEngine;





  /* ==========================================================================

     5. REVEAL ENGINE

     ----------------------------------------------------------------------------

     Activa animaciones solo cuando el elemento entra en pantalla (scroll).

     Agrega la clase .bb-in-view una sola vez, la primera vez que el elemento

     se vuelve visible. Sirve tanto para un fade-in genérico (.bb-anim-reveal)

     como para disparar ciclos más complejos (ej. el dúo de productos, que

     escucha por su propia clase .bb-duo-in agregada aquí también).

     config = { elements: HTMLElement[], activeClass: string, threshold: number }

     ========================================================================== */

  var RevealEngine = {

    init: function (config) {

      var elements = config.elements || [];

      var activeClass = config.activeClass || 'bb-in-view';

      var threshold = config.threshold != null ? config.threshold : 0.3;



      elements.forEach(function (el) {

        if (!el) return;

        if (!('IntersectionObserver' in window)) {

          el.classList.add(activeClass);

          return;

        }

        var obs = new IntersectionObserver(function (entries) {

          entries.forEach(function (entry) {

            if (entry.isIntersecting) {

              el.classList.add(activeClass);

              obs.unobserve(el);

            }

          });

        }, { threshold: threshold });

        obs.observe(el);

      });

    }

  };

  BannerBuilder.RevealEngine = RevealEngine;





  /* ==========================================================================

     6. STOCK COUNTDOWN ENGINE

     ----------------------------------------------------------------------------

     "¡Solo quedan N!" - baja de a poco desde un número inicial hasta un piso,

     y vuelve a empezar. config = { element, start, floor, intervalMs }

     ========================================================================== */

  var StockCountdownEngine = {

    init: function (config) {

      var el = config.element;

      if (!el) return;

      var start = config.start || 12;

      var floor = config.floor || 4;

      var count = start;

      el.textContent = count;



      setInterval(function () {

        count -= 1;

        if (count < floor) count = start;

        el.textContent = count;

        el.classList.remove('bb-bump-active');

        void el.offsetWidth;

        el.classList.add('bb-bump-active');

      }, config.intervalMs || 15000);

    }

  };

  BannerBuilder.StockCountdownEngine = StockCountdownEngine;





  /* ==========================================================================

     7. SOCIAL PROOF ENGINE

     ----------------------------------------------------------------------------

     "Y 1,567 personas ya compraron" - número que sube de a uno cada tanto,

     con una animación de "salto" en el número y una estrellita que aparece.

     config = { countElement, starElement, start, max, intervalMinMs, intervalMaxMs }

     ========================================================================== */

  var SocialProofEngine = {

    init: function (config) {

      var countEl = config.countElement;

      if (!countEl) return;

      var starEl = config.starElement;

      var start = config.start || 1000;

      var max = config.max || 2000;

      var count = start;



      function format(n) {

        return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      }

      function bump() {

        count += 1;

        if (count > max) count = start;

        countEl.textContent = format(count);

        countEl.classList.remove('bb-bump-active');

        void countEl.offsetWidth;

        countEl.classList.add('bb-bump-active');

        if (starEl) {

          starEl.classList.remove('bb-pop-active');

          void starEl.offsetWidth;

          starEl.classList.add('bb-pop-active');

        }

      }

      function scheduleNext() {

        var lo = config.intervalMinMs || 2200;

        var hi = config.intervalMaxMs || 5000;

        setTimeout(function () { bump(); scheduleNext(); }, Utils.rand(lo, hi));

      }

      countEl.textContent = format(count);

      scheduleNext();

    }

  };

  BannerBuilder.SocialProofEngine = SocialProofEngine;





  /* ==========================================================================

     8. PRICE FLASH ENGINE

     ----------------------------------------------------------------------------

     Destello de luz que recorre el precio cada tantos segundos (aleatorio

     dentro de un rango), para llamar la atención sin ser una animación fija

     y predecible. config = { element, minDelayMs, maxDelayMs }

     ========================================================================== */

  var PriceFlashEngine = {

    init: function (config) {

      var el = config.element;

      if (!el) return;

      var lo = config.minDelayMs || 3500;

      var hi = config.maxDelayMs || 7500;



      function trigger() {

        el.classList.remove('bb-flash-active');

        void el.offsetWidth;

        el.classList.add('bb-flash-active');

        setTimeout(trigger, Utils.rand(lo, hi));

      }

      setTimeout(trigger, 1800);

    }

  };

  BannerBuilder.PriceFlashEngine = PriceFlashEngine;





  /* ==========================================================================

     9. COMPONENT REGISTRY

     ----------------------------------------------------------------------------

     Cada componente activable en el panel de Shopify tiene aquí una función

     de arranque. Agregar un componente nuevo = agregar una entrada aquí,

     sin tocar el resto del motor.

     ========================================================================== */

  var Registry = {



    star_rain: function (root, cfg) {

      var mount = root.querySelector('[data-bb-star-rain]');

      if (!mount) return;

      ParticleEngine.init({

        container: mount,

        heightRef: root,

        mode: 'rain',

        shape: 'star',

        count: cfg.count || 10,

        colors: cfg.colors || ['#BE8C56', '#D9B27C', '#E8C996', '#A87643'],

        sizeMin: 4, sizeMax: 8,

        durationMin: 7, durationMax: 12,

        delayMax: 10,

        burst: true

      });

    },



    product_stream: function (root, cfg) {

      var mount = root.querySelector('[data-bb-product-stream]');

      if (!mount) return;

      ParticleEngine.init({

        container: mount,

        mode: 'stream',

        instanceId: cfg.instanceId || Math.random().toString(36).slice(2, 7),

        count: cfg.count || 8,

        startX: cfg.startX || [45, 51],

        startY: cfg.startY || [24, 29],

        endX: cfg.endX || [19, 33],

        endY: cfg.endY || [50, 59],

        sizeMin: 7, sizeMax: 13,

        durationMin: 1.5, durationMax: 2.6,

        delayMax: 2.4,

        streamGradient: cfg.gradient,

        burst: true

      });

    },



    countdown: function (root, cfg) {

      function all(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

      CountdownEngine.init({

        elements: {

          d: all('[data-bb-cd="d"]'),

          h: all('[data-bb-cd="h"]'),

          m: all('[data-bb-cd="m"]'),

          s: all('[data-bb-cd="s"]')

        },

        startSeconds: typeof cfg.startSeconds === 'number' ? cfg.startSeconds : 3600,

        loop: cfg.loop !== false,

        tickMs: cfg.tickMs || 1000

      });

    },



    fullwidth_countdown: function (root, cfg) {

      function all(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

      CountdownEngine.init({

        elements: {

          h: all('[data-bb-fw-cd="h"]'),

          m: all('[data-bb-fw-cd="m"]'),

          s: all('[data-bb-fw-cd="s"]')

        },

        startSeconds: typeof cfg.startSeconds === 'number' ? cfg.startSeconds : 3600,

        loop: cfg.loop !== false,

        tickMs: cfg.tickMs || 1000

      });

    },



    live_viewers: function (root, cfg) {

      LiveViewersEngine.init({

        element: root.querySelector('[data-bb-live-viewers]'),

        min: cfg.min || 8,

        max: cfg.max || 34,

        intervalMs: cfg.intervalMs || 4000,

        rampUp: cfg.rampUp || null

      });

    },



    scroll_reveal: function (root, cfg) {

      var els = root.querySelectorAll('.bb-anim-reveal:not(.bb-duo)');

      if (!els.length) return;

      RevealEngine.init({ elements: Array.prototype.slice.call(els), activeClass: 'bb-in-view', threshold: 0.25 });

    },



    duo_product: function (root, cfg) {

      var duo = root.querySelector('[data-bb-duo]');

      if (!duo) return;

      RevealEngine.init({ elements: [duo], activeClass: 'bb-duo-in', threshold: 0.35 });

    },



    gallery: function (root, cfg) {

      var grid = root.querySelector('[data-bb-gallery]');

      if (!grid) return;

      RevealEngine.init({ elements: [grid], activeClass: 'bb-gallery-in', threshold: 0.2 });

    },



    stock_countdown: function (root, cfg) {

      StockCountdownEngine.init({

        element: root.querySelector('[data-bb-stock-count]'),

        start: cfg.start || 12,

        floor: cfg.floor || 4,

        intervalMs: cfg.intervalMs || 15000

      });

    },



    social_proof: function (root, cfg) {

      SocialProofEngine.init({

        countElement: root.querySelector('[data-bb-social-count]'),

        starElement: root.querySelector('[data-bb-social-star]'),

        start: cfg.start || 1000,

        max: cfg.max || 2000,

        intervalMinMs: cfg.intervalMinMs || 2200,

        intervalMaxMs: cfg.intervalMaxMs || 5000

      });

    },



    price_flash: function (root, cfg) {

      PriceFlashEngine.init({

        element: root.querySelector('[data-bb-price-flash]'),

        minDelayMs: cfg.minDelayMs || 3500,

        maxDelayMs: cfg.maxDelayMs || 7500

      });

    }

  };

  BannerBuilder.Registry = Registry;





  /* ==========================================================================

     10. BOOTSTRAP

     ----------------------------------------------------------------------------

     Busca cada banner en la página (puede haber varios), lee su configuración

     JSON incrustada y activa únicamente los componentes que ese banner trae.

     ========================================================================== */

  function bootstrapBanner(root) {

    if (root.getAttribute('data-bb-initialized') === 'true') return;
    root.setAttribute('data-bb-initialized', 'true');

    var configTag = root.querySelector('script.bb-config');

    if (!configTag) return;



    var config;

    try {

      config = JSON.parse(configTag.textContent);

    } catch (e) {

      if (window.console) console.warn('[BannerBuilder] Config inválida en', root.id, e);

      return;

    }



    var components = config.components || {};

    for (var name in components) {

      if (!components.hasOwnProperty(name)) continue;

      var componentConfig = components[name];

      if (!componentConfig || componentConfig.enabled === false) continue;

      var fn = Registry[name];

      if (typeof fn === 'function') {

        try { fn(root, componentConfig); }

        catch (err) { if (window.console) console.warn('[BannerBuilder] Error en componente', name, err); }

      }

    }

  }



  function bootstrapAll() {

    var banners = document.querySelectorAll('.bb-hero[data-bb-root]');

    for (var i = 0; i < banners.length; i++) {

      bootstrapBanner(banners[i]);

    }

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', bootstrapAll);

  } else {

    bootstrapAll();

  }



  window.BannerBuilder = BannerBuilder;



})(window, document);